import { useCallback, useRef, useState } from 'react';
import type { ImperativePanelHandle } from 'react-resizable-panels';
import { useSidebar } from '@/Domain/components/Shared/Sidebar/Sidebar';

// One toggle that hides/shows both the sidebar and the left panel; isFocused only when both are hidden.
export const usePreviewFocusToggle = () => {
  const leftPanelRef = useRef<ImperativePanelHandle>(null);
  const { state, setOpen } = useSidebar();
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);

  const isFocused = state === 'collapsed' && isLeftPanelCollapsed;

  const toggleFocus = useCallback(() => {
    if (isFocused) {
      setOpen(true);
      leftPanelRef.current?.expand();
    } else {
      setOpen(false);
      leftPanelRef.current?.collapse();
    }
  }, [isFocused, setOpen]);

  const collapseLeftPanel = useCallback(() => {
    leftPanelRef.current?.collapse();
  }, []);

  const expandLeftPanel = useCallback(() => {
    leftPanelRef.current?.expand();
  }, []);

  return {
    leftPanelRef,
    isFocused,
    isLeftPanelCollapsed,
    toggleFocus,
    collapseLeftPanel,
    expandLeftPanel,
    onLeftPanelCollapsedChange: setIsLeftPanelCollapsed,
  };
};
